import React, { useRef, useState } from "react";
import Modal from "../base/Modal";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import { FaArrowLeftLong } from "react-icons/fa6";
import SelectedTriggerItem from "../form/SelectedTriggerItem";
import useClickOutside from "../../hooks/useClickOutside";
const GroupsModal = ({ isOpen, onClose, openAddGroup }) => {
  const [allGroups, setAllGroups] = useState([
    {
      id: 1,
      title: "My group",
      desc: "",
      apps: [
        {
          id: 1,
          label: "Jira",
          value: "jira",
          image:
            "https://res.cloudinary.com/dsguoq6ad/image/upload/v1726228864/mentorEducationImages/x3hajcpo5sbpdb0klxvu.png",
          functions: [
            "MANAGE Issues",
            "MANAGE Watchers",
            "MANAGE Comments",
            "MANAGE Jira Projects",
            "CREATE Issue Type",
            "DELETE Issue Type",
          ],
          unique_index: 0,
          selectedFunctions: [
            "CREATE Issue Type",
            "MANAGE Issues",
            "DELETE Issue Type",
            "MANAGE Watchers",
            "MANAGE Comments",
            "MANAGE Jira Projects",
          ],
        },
        {
          id: 2,
          label: "Google Calendar",
          value: "google_calendar",
          image:
            "https://res.cloudinary.com/dsguoq6ad/image/upload/v1726228690/mentorEducationImages/z9uxgo6owonunaeawede.png",
          functions: [
            "MANAGE Events",
            "MANAGE Calendars",
            "MANAGE Google Meet",
          ],
          unique_index: 1,
          selectedFunctions: [
            "MANAGE Calendars",
            "MANAGE Google Meet",
            "MANAGE Events",
          ],
        },
        {
          id: 14,
          label: "Teams",
          value: "teams",
          function: [],
          image:
            "https://res.cloudinary.com/dsguoq6ad/image/upload/v1727457135/mentorEducationImages/vr3wpu2bzwdhyqd9hq19.png",
          unique_index: 10,
          selectedFunctions: [],
        },
        {
          id: 6,
          label: "Google Keep",
          value: "google_keep",
          image:
            "https://res.cloudinary.com/dsguoq6ad/image/upload/v1727611983/mentorexperienceImages/mrmv6hsx7crykznjg7dp.png",
          functions: ["Note Management"],
        },
        {
          id: 13,
          label: "Linear",
          value: "linear",
          function: [],
          image:
            "https://res.cloudinary.com/dsguoq6ad/image/upload/v1727457317/mentorEducationImages/epy1xtlquycftuooe8vw.png",
        },
        {
          id: 14,
          label: "Teams",
          value: "teams",
          function: [],
          image:
            "https://res.cloudinary.com/dsguoq6ad/image/upload/v1727457135/mentorEducationImages/vr3wpu2bzwdhyqd9hq19.png",
        },
        {
          id: 15,
          label: "Google tasks",
          value: "google_tasks",
          function: [],
          image:
            "https://res.cloudinary.com/dsguoq6ad/image/upload/v1727457121/mentorEducationImages/thywjdnrzkhqtp1caxrk.png",
        },
      ],
    },
  ]);

  const [dropdownOpen, setDropdownOpen] = useState(null);
  const toggleDropdown = (botId) => {
    setDropdownOpen((prev) => (prev === botId ? null : botId));
  };

  const dropdownRef = useRef(null);
  useClickOutside([dropdownRef], () => toggleDropdown(null));

  const [editGroup, setEditGroup] = useState(null);
  const handleEditClick = (group) => {
    setEditGroup(group);
  };
  const handleDeleteApp = (groupId, appId) => {
    setAllGroups((prevGroups) =>
      prevGroups.map((group) =>
        group.id === groupId
          ? {
              ...group,
              apps: group.apps.filter((app) => app.id !== appId),
            }
          : group
      )
    );
  };

  return (
    <Modal title="Groups" isOpen={isOpen} onClose={onClose}>
      <div className="p-5 px-8 flex flex-col justify-between gap-3 min-h-96">
        <div className="flex flex-col gap-3 overflow-auto flex-1">
          {allGroups.map((item, index) => (
            <div
              key={index}
              className="flex flex-col gap-2 relative py-2 px-3 rounded-md border border-zinc-700 bg-zinc-800 transition-colors duration-150 ease-in-out cursor-pointer hover:border-neutral-600"
            >
              <div className="flex items-center">
                {item.apps.slice(0, 6).map((app, index) => (
                  <div
                    key={index}
                    className="flex flex-shrink-0 items-center justify-center w-5 h-5 p-0.5 border border-zinc-700 bg-zinc-200 -ml-2 rounded-full"
                  >
                    <img
                      alt="Gmail: Add Label to Email"
                      loading="lazy"
                      width="24"
                      height="24"
                      src={app.image}
                    />
                  </div>
                ))}
                <p className="flex-1 truncate text-sm font-medium ml-2">
                  {item.title}
                </p>
                <div className="flex gap-1 relative z-10">
                  <button
                    onClick={() => toggleDropdown(item.id)}
                    className="rounded-[3px] text-md font-semibold transition-colors duration-150 ease-in-out disabled:cursor-not-allowed -mr-1 py-1 px-1 border-0 bg-transparent flex items-center text-zinc-300 hover:bg-zinc-700"
                  >
                    <PiDotsThreeOutlineVerticalFill className="text-xl" />
                  </button>
                </div>
                {dropdownOpen === item.id && (
                  <div
                    className="absolute right-0 top-10 w-48 bg-1 border br-1 z-20 p-2 rounded-xl text-s-text"
                    ref={dropdownRef}
                  >
                    <button className="block bg-1-hover px-4 py-2 text-sm w-full text-left rounded-xl">
                      Duplicate Group
                    </button>
                    <button
                      onClick={() => {
                        openAddGroup();
                        onClose();
                        setDropdownOpen(null);
                      }}
                      className="block bg-1-hover px-4 py-2 text-sm w-full text-left rounded-xl"
                    >
                      Edit
                    </button>
                    <button className="block bg-1-hover px-4 py-2 text-sm w-full text-left rounded-xl">
                      Share
                    </button>
                    <button className="block bg-1-hover px-4 py-2 text-sm w-full text-left rounded-xl">
                      Delete
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        <div>
          <button
            onClick={() => {
              openAddGroup();
              onClose();
            }}
            className="bg-zinc-800 border border-zinc-700 px-3 py-1 rounded-lg text-sm"
          >
            + Add Group
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default GroupsModal;
